const state = {
	recollectData: [],
	recollectQueries: []
}

export default state
